import { motion } from "framer-motion";
import DemoHealthScore from "./DemoHealthScore";
import DemoAlerts from "./DemoAlerts";
import DemoPredictions from "./DemoPredictions";
import DemoMetrics from "./DemoMetrics";

const DemoPhoneMockup = () => {
  return (
    <div className="relative">
      {/* Glow effect behind phone */}
      <div className="absolute inset-0 bg-emerald-500/20 blur-[60px] rounded-full scale-75" />

      {/* Phone Frame */}
      <div className="relative bg-slate-900 rounded-[3rem] p-3 shadow-2xl shadow-slate-900/50 rotate-1 hover:rotate-0 transition-transform duration-500">
        {/* Phone notch */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-7 bg-slate-900 rounded-b-2xl z-20" />

        {/* Screen */}
        <div className="relative bg-slate-50 rounded-[2.5rem] overflow-hidden w-[280px] sm:w-[320px] h-[580px] sm:h-[640px]">
          {/* Status bar */}
          <div className="h-12 bg-emerald-600 flex items-end justify-center pb-2">
            <span className="text-white/90 text-xs font-medium">CynthIA</span>
          </div>

          {/* App content */}
          <div className="p-4 space-y-3 overflow-hidden">
            {/* Health Score */}
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
            >
              <DemoHealthScore />
            </motion.div>

            {/* Metrics */}
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
            >
              <DemoMetrics />
            </motion.div>

            {/* Alerts */}
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.6 }}
            >
              <DemoAlerts />
            </motion.div>

            {/* Predictions */}
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.8 }}
            >
              <DemoPredictions />
            </motion.div>
          </div>

          {/* Bottom nav mockup */}
          <div className="absolute bottom-0 left-0 right-0 h-16 bg-white border-t border-slate-200 flex items-center justify-around px-6">
            <NavItem active label="Accueil" />
            <NavItem label="Zones" />
            <NavItem label="Stats" />
            <NavItem label="Réglages" />
          </div>
        </div>
      </div>

      {/* Floating badge */}
      <motion.div
        className="absolute -right-4 top-20 bg-white rounded-xl shadow-lg px-3 py-2 border border-slate-100"
        initial={{ opacity: 0, x: 20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 1 }}
      >
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse" />
          <span className="text-xs font-medium text-slate-700">Données en direct</span>
        </div>
      </motion.div>

      {/* Floating badge 2 */}
      <motion.div
        className="absolute -left-4 bottom-32 bg-emerald-600 rounded-xl shadow-lg px-3 py-2"
        initial={{ opacity: 0, x: -20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 1.2 }}
      >
        <span className="text-xs font-bold text-white">+40% d'eau économisée</span>
      </motion.div>
    </div>
  );
};

const NavItem = ({ label, active }: { label: string; active?: boolean }) => (
  <div className="flex flex-col items-center gap-1">
    <div
      className={`w-5 h-5 rounded-full ${
        active ? "bg-emerald-600" : "bg-slate-300"
      }`}
    />
    <span
      className={`text-[10px] ${
        active ? "text-emerald-600 font-semibold" : "text-slate-400"
      }`}
    >
      {label}
    </span>
  </div>
);

export default DemoPhoneMockup;
